<!-- 组件说明 -->
<template>
  <div class="designer_wrapper">
    <!-- <mt-header fixed :title="componentItems[0].prop.title"></mt-header>
    <language :class="{actives:isactive}"></language> -->
    <div class="topHeigh"></div>
    <div v-if="componentItems[0].prop.search=='0'" class="search_wrapper">
      <!-- <mt-search v-model="value" cancel-text="取消" placeholder="搜索">
      </mt-search>-->
      <!-- <van-notice-bar
        scrollable 
        v-if="noticeStatus"
        :text="noticeValue"
        left-icon="volume-o"
        background="#fbfbfb"
        color="rgb(238, 10, 36)"
      /> -->
      <van-notice-bar
        scrollable
        v-if="noticeStatus"
        left-icon="volume-o"
        :text="noticeValue"
      />
      <!-- <button type="button" class="btn btn-success" @click="changeLocale">中文/EN</button> -->

      <!-- <van-dropdown-menu>
          <van-dropdown-item v-model="value1" :change="setlang(value1)" :options="option1" />
      </van-dropdown-menu>-->
      <van-search
        v-model="searchValue"
        :placeholder="$t('index.placeholder')"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div>
    <div v-for="(item) in componentItems" :key="item.id">
      <loader :item="item"></loader>
    </div>
    <div class="site">
      <span v-for="(item,index) in siteList" :key="index" @click="toDetail(item.id,item.region)">
        {{item.title}}
        <span v-if="index<(siteList.length-1)"></span>
      </span>
    </div>
  </div>
</template>

<script>
import { Search, Loading, NoticeBar } from "vant";
import home from "@/api/home";
import goods from "@/api/goods";
import Loader from "./ComponentLoader";
import language from "./Language";
import { mapMutations, mapState } from "vuex";
export default {
  components: { Loader, language },
  data() {
    return {
      value: "0",
      componentItems: [{ prop: {} }],
      searchValue: "",
      loadingShow: true,
      noticeValue: "", //公告内容
      noticeStatus: true, //公告栏的状态
      siteList: [],
      model1: "1",
      lang: null,
      sendPop: false,
      isactive: true,
    };
  },
  computed: {
    // ...mapState('designer', {
    //   componentItems: 'components',
    // }),
    indexData: {
      get() {
        // debugger
        return this.$store.state.user.indexData;
      }
    },
    regionData: {
      get() {
        return this.$store.state.user.regionData;
      }
    },
  },
  watch: {
    indexData: {
      handler(newValue,oldValue){ //当词条改变时执行事件
        // console.log('new',oldValue)
        this.getInfo();
        this.onInfo(newValue)
      }
    },
    regionData: {
      handler(newValue,oldValue){ //当改变时执行事件
      //  this.onInfo(newValue)
      }
    }
  },
  methods: {
    toDetail(id,region) {
      this.$router.push({ name: "siteDetail", params: { id: id,region: region } });
    },
    onSearch(val) {
      //搜索功能
      this.$emit("toSearch", val);
      // this.currentPage = 1  //当前页数为1
      // this.getsearchProdPage(val)
    },
    onInfo(data){
      // if(!data){
        // 加载首页站点
        goods.topSiteList({ shopId: this.$store.state.designer.shopId,region:sessionStorage.getItem('REG') }).then(res => {
           this.siteList = res;
        })
      // }
        // if(!data){
        //   if(this.regionData){
        //     debugger
        //       goods.topSiteList({ shopId: this.regionData.shopId,region:this.regionData.region }).then(res => {
        //         this.siteList = res;
        //       });
        //   }
        // }else{
        //   debugger
        //   goods.topSiteList({ shopId: data.shopId,region:data.region }).then(res => {
        //     this.siteList = res;
        //   });
        // }
    },
    getInfo() {
      let host = location.host; //线上
      // home.index(host).then(res => {
        let res = this.indexData;
        if(!res){
            return false;
        }
        // console.info(res)
        this.loadingShow = false;
        this.$store.commit("designer/setShopId", res.shopId);
        let content = JSON.parse(res.content);
        this.componentItems = content;
        sessionStorage.setItem('title',this.componentItems[0].prop.title)
        document.title = this.componentItems[0].prop.title;
        this.$store.commit("designer/setTitleName", document.title);

        //facebook-像素
        let FbqIdList = sessionStorage.getItem("FbqIdList");

        //获取店铺的url
        // sessionStorage.removeItem("shopUrl")
        // home.shopUrl({shopId:res.shopId}).then((res) => {
        //     sessionStorage.setItem("shopUrl", 'https://'+res.shopUrl+'/h5');
        // })
        goods.topNoticeList({ shopId: res.shopId,region:this.$store.state.user.indexData.region}).then(res => {
          if (res.length != 0) {
            this.noticeValue = res[0].title;
          } else {
            this.noticeStatus = false;
          }
        });

        
      // });
    },
    onCancel() {}

    // changeLocale () {
    //   this.$confirm(this.$t('切換語言'), this.$t('切換語言'), {
    //       confirmButtonText: this.$t('ok'),
    //       cancelButtonText: this.$t('cancel'),
    //       type: 'warning'
    //       }).then(() => {
    //         let locale = this.$i18n.locale
    //         locale === 'zh' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'zh'
    //       }).catch(() => {
    //             this.$message({
    //                 type: 'info',
    //                 })
    //       })
    // },
  },
  mounted() {
    this.getInfo();
    // this.onInfo(0);
  },
  created() {
    //生命周期 - 创建完成
    // this.getInfo();
    // console.log("window.location.href", window.location);
    // $.get("https://jsonip.com", function(res) {
    //   console.log("IP Address is: " + res.ip);
    // });
  },
  destroyed() {
    //生命周期 - 销毁完成
  }
};
</script>

<style lang='scss' scope>
.topHeigh {
  margin-top: 40px;
}
.designer_wrapper {
  // padding-bottom: 2rem;
  .search_wrapper {
    margin-bottom: 10px;
  }
  .mint-header {
    background: #fff;
    color: #333;
  }
  .mint-header.is-fixed {
    z-index: 100;
  }
}
.site {
  margin: 30px 0;
  text-align: center;
  padding: 0 30px;
  font-size: 14px;
}
.site span{
  padding: 2px 0;
  display: block;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
.radio_item {
  padding: 5px;
}
.actives {
  padding: 0 15px;
  font-size: 14px;
  z-index: 9999;
  position: absolute;
  right: 0;
  top: 0;
  height: 46px;
}
</style>


// WEBPACK FOOTER //
// src/pages/index/common/ViewPort.vue